/*
 * État partagé du formulaire de devis multi-pages (devis-1 à devis-8).
 * Chaque page est une vraie page Shopify (rechargement complet) : l'état
 * voyage via sessionStorage, pas en mémoire JS. Voir docs/01-architecture.md.
 *
 * Refonte v2 (2026-08-31) : le parcours est passé de 10 à 8 pages —
 * l'ancien devis-3 (deux façons d'avancer) a rejoint devis-2, et l'ancien
 * devis-6 (les mots) a rejoint le grand écran produit. Toutes les pages
 * suivantes ont été décalées d'autant.
 */
(function () {
  var STORAGE_KEY = 'cachoteries-devis-state';

  function getState() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function setState(partial) {
    var state = getState();
    Object.assign(state, partial);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    return state;
  }

  function mergeField(field) {
    if (!field.name) return;
    var state = getState();
    if (field.type === 'checkbox') {
      var form = field.form || document;
      state[field.name] = Array.prototype.map.call(
        form.querySelectorAll('[name="' + field.name + '"]:checked'),
        function (c) { return c.value; }
      );
    } else {
      state[field.name] = field.value;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  // Relit l'état stocké et pré-remplit tous les champs correspondants du
  // formulaire donné (permet de revenir en arrière sans perte de saisie).
  function bindForm(form) {
    if (!form) return;
    var state = getState();

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || !(field.name in state)) return;
      var value = state[field.name];
      if (field.type === 'checkbox') {
        field.checked = Array.isArray(value) && value.indexOf(field.value) !== -1;
      } else if (field.type === 'radio') {
        field.checked = field.value === value;
      } else if (field.type !== 'file') {
        field.value = value;
      }
    });

    form.addEventListener('change', function (e) { if (e.target.name) mergeField(e.target); });
    form.addEventListener('input', function (e) {
      if (e.target.name && e.target.type !== 'checkbox' && e.target.type !== 'radio') mergeField(e.target);
    });
  }

  // Resynchronise TOUT le formulaire dans l'état, y compris les champs jamais
  // touchés par l'utilisateur. À appeler juste avant de naviguer.
  function syncForm(form) {
    var partial = {};
    var seen = {};
    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || seen[field.name]) return;
      if (field.type === 'checkbox') {
        partial[field.name] = Array.prototype.map.call(
          form.querySelectorAll('[name="' + field.name + '"]:checked'),
          function (c) { return c.value; }
        );
        seen[field.name] = true;
      } else if (field.type === 'radio') {
        var checked = form.querySelector('[name="' + field.name + '"]:checked');
        if (checked) partial[field.name] = checked.value;
        seen[field.name] = true;
      } else {
        partial[field.name] = field.value;
      }
    });
    setState(partial);
  }

  /* ---------------------------------------------------------------------
   * Formats d'emballage — source unique, partagée par l'écran produit
   * (devis-4) et le récapitulatif (devis-7).
   *
   * `parUnite` = nombre de biscuits contenus dans une unité vendue. Le client
   * saisit un nombre d'UNITÉS (des biscuits pour le vrac, des sachets, des
   * coffrets) ; le total en biscuits en est déduit. C'est la règle posée par
   * l'utilisateur le 2026-08-31 : « 35 biscuits en vrac et 4 grands coffrets
   * soit 83 biscuits au total » (35 + 4 × 12).
   * ------------------------------------------------------------------- */
  var FORMATS = [
    { key: 'vrac',              parUnite: 1,  nom: ['biscuit en vrac', 'biscuits en vrac'],       question: 'Combien de biscuits en vrac&nbsp;?' },
    { key: 'sachet_individuel', parUnite: 1,  nom: ['sachet individuel', 'sachets individuels'],  question: 'Combien de sachets individuels&nbsp;?' },
    { key: 'sachet_duo',        parUnite: 2,  nom: ['sachet duo', 'sachets duo'],                 question: 'Combien de sachets duo&nbsp;?' },
    { key: 'coffret_x4',        parUnite: 4,  nom: ['petit coffret', 'petits coffrets'],          question: 'Combien de petits coffrets&nbsp;?' },
    { key: 'coffret_x12',       parUnite: 12, nom: ['grand coffret', 'grands coffrets'],          question: 'Combien de grands coffrets&nbsp;?' }
  ];

  // « 4 grands coffrets » — le pluriel porte sur l'adjectif autant que sur le
  // nom, d'où la paire explicite plutôt qu'un « s » ajouté à la volée.
  function nommer(format, n) {
    return n + ' ' + (n > 1 ? format.nom[1] : format.nom[0]);
  }

  function formatByKey(key) {
    for (var i = 0; i < FORMATS.length; i++) if (FORMATS[i].key === key) return FORMATS[i];
    return null;
  }

  function qteFormat(state, key) {
    return Number(state['qte_' + key]) || 0;
  }

  // Total de biscuits, déduit des quantités par format. Remplace l'ancien
  // champ « Combien de biscuits souhaitez-vous ? », supprimé le 2026-08-31.
  function totalBiscuits(state) {
    return FORMATS.reduce(function (sum, f) {
      return sum + qteFormat(state, f.key) * f.parUnite;
    }, 0);
  }

  // « 35 biscuits en vrac et 4 grands coffrets » — le fragment réutilisé par
  // le récap de l'écran produit et par le récapitulatif final.
  function detailFormats(state) {
    var parts = FORMATS.filter(function (f) { return qteFormat(state, f.key) > 0; })
      .map(function (f) { return nommer(f, qteFormat(state, f.key)); });
    if (!parts.length) return '';
    if (parts.length === 1) return parts[0];
    return parts.slice(0, -1).join(', ') + ' et ' + parts[parts.length - 1];
  }

  /* ------------------------------------------------------------------- */

  // Ordre des pages avec jauge : de « Vous êtes » au récapitulatif. La page
  // abonnement est réservée aux professionnels : la retirer du décompte pour
  // les particuliers évite que leur jauge saute un cran (3/6 puis 5/6).
  // Tant que le profil n'est pas choisi, on compte le parcours le plus court.
  function progressSteps() {
    var steps = ['devis-2', 'devis-3', 'devis-4', 'devis-5', 'devis-6', 'devis-7'];
    if (isPro()) return steps;
    return steps.filter(function (key) { return key !== 'devis-5'; });
  }

  function renderProgress(pageKey) {
    var bar = document.querySelector('[data-devis-progress]');
    if (!bar) return;
    var steps = progressSteps();
    var idx = steps.indexOf(pageKey);
    if (idx === -1) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    var pct = Math.round(((idx + 1) / steps.length) * 100);
    var fill = bar.querySelector('[data-devis-progress-fill]');
    var label = bar.querySelector('[data-devis-progress-label]');
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = 'Étape ' + (idx + 1) + ' sur ' + steps.length;
  }

  function isPro() {
    return getState().profil === 'professionnel';
  }

  // Encadre en rouge le champ (ou fieldset) le plus proche d'un contrôle
  // invalide au moment où le navigateur bloque le « Suivant ».
  function closestInvalidWrap(target) {
    if (!target.closest) return null;
    return target.closest('.devis-form__field')
      || target.closest('fieldset')
      || target.closest('.devis-form__cards')
      || target.closest('.devis-form__slots');
  }

  // ---- Message de blocage ---------------------------------------------------
  // Encadrer le champ fautif ne suffit pas : il est souvent hors de l'écran au
  // moment du clic, et le « Suivant » paraît alors ne rien faire. On affiche
  // donc la raison en bas de l'écran, à l'endroit où l'œil est déjà posé.

  var blocageMasquage = null;

  function blocageEl() {
    var el = document.querySelector('[data-devis-blocage]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'devis-blocage';
    el.setAttribute('data-devis-blocage', '');
    // « alert » fait lire le message par les lecteurs d'écran dès son
    // apparition, sans lui voler le focus : celui-ci reste au champ fautif,
    // que reportValidity() vient de cibler.
    el.setAttribute('role', 'alert');
    el.hidden = true;
    document.body.appendChild(el);
    return el;
  }

  function showBlocage(message) {
    if (!message) return;
    var el = blocageEl();
    el.textContent = message;
    el.hidden = false;
    clearTimeout(blocageMasquage);
    blocageMasquage = setTimeout(hideBlocage, 10000);
  }

  function hideBlocage() {
    var el = document.querySelector('[data-devis-blocage]');
    if (el) el.hidden = true;
    clearTimeout(blocageMasquage);
  }

  // Intitulé lisible d'un contrôle, pour nommer le blocage. On remonte au bloc
  // qui porte le libellé plutôt que de se fier à un for/id : le formulaire
  // mélange <label> englobants, <legend> et cartes sans libellé propre.
  function libelleDe(control) {
    var pack = control.closest('.devis-pack');
    if (pack) {
      var nom = pack.querySelector('.devis-pack__label');
      if (nom) return texte(nom);
    }

    var formule = control.closest('.devis-formule');
    if (formule) {
      var nomF = formule.querySelector('.devis-formule__name');
      if (nomF) return texte(nomF);
    }

    var wrap = closestInvalidWrap(control);
    if (wrap) {
      var propre = wrap.querySelector('legend, .devis-form__label');
      if (propre) return texte(propre);
      // Les cartes de choix n'ont pas de libellé à l'intérieur : le leur est
      // posé juste au-dessus du bloc.
      var precedent = wrap.previousElementSibling;
      while (precedent) {
        if (precedent.matches('.devis-form__label, legend')) return texte(precedent);
        precedent = precedent.previousElementSibling;
      }
    }
    return '';
  }

  function texte(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').replace(/\s*[:?]\s*$/, '').trim();
  }

  // Raison en français, plutôt que le message natif du navigateur : celui-ci
  // suit la langue du navigateur et non celle de la boutique.
  function raisonDe(control) {
    var v = control.validity;
    var estChoix = control.type === 'radio' || control.type === 'checkbox';
    if (v.valueMissing) return estChoix ? 'faites un choix' : 'ce champ est obligatoire';
    if (v.typeMismatch) return control.type === 'email'
      ? 'cette adresse e-mail n\'est pas valide'
      : 'ce format n\'est pas valide';
    if (v.rangeUnderflow) return 'la valeur est trop petite (minimum ' + control.min + ')';
    if (v.rangeOverflow) return 'la valeur est trop grande (maximum ' + control.max + ')';
    if (v.tooShort) return 'ce champ est trop court';
    if (v.tooLong) return 'ce champ est trop long';
    if (v.stepMismatch) return 'indiquez un nombre entier';
    if (v.patternMismatch) return 'le format attendu n\'est pas respecté';
    return control.validationMessage || 'ce champ est à corriger';
  }

  function messageDeBlocage(controls) {
    var vus = [];
    controls.forEach(function (c) {
      var nom = libelleDe(c);
      var deja = vus.some(function (e) { return e.nom === nom; });
      if (!deja) vus.push({ nom: nom, raison: raisonDe(c) });
    });
    if (!vus.length) return '';

    if (vus.length === 1) {
      var seul = vus[0];
      return seul.nom
        ? 'Impossible de continuer : « ' + seul.nom +' » — ' + seul.raison + '.'
        : 'Impossible de continuer : ' + seul.raison + '.';
    }

    var noms = vus.map(function (e) { return e.nom; }).filter(Boolean);
    return 'Impossible de continuer : ' + vus.length + ' champs à compléter'
      + (noms.length ? ' (' + noms.join(', ') + ')' : '') + '.';
  }

  function attachInvalidStyling(form) {
    // reportValidity() émet un « invalid » par contrôle fautif, de façon
    // synchrone : on les accumule et on ne compose le message qu'une fois la
    // salve terminée, pour annoncer tous les champs d'un coup.
    var salve = [];

    form.addEventListener('invalid', function (e) {
      var wrap = closestInvalidWrap(e.target);
      if (wrap) wrap.classList.add('devis-form__field--invalid');

      if (!salve.length) {
        setTimeout(function () {
          showBlocage(messageDeBlocage(salve));
          salve = [];
        }, 0);
      }
      salve.push(e.target);
    }, true);

    form.addEventListener('input', function (e) { clearInvalid(e.target); });
    form.addEventListener('change', function (e) { clearInvalid(e.target); });

    function clearInvalid(target) {
      var wrap = closestInvalidWrap(target);
      if (wrap) wrap.classList.remove('devis-form__field--invalid');
      hideBlocage();
    }
  }

  // Popup d'aide (snippets/devis-help-popup.liquid). Le CSS .contact-popup est
  // bundlé globalement, le JS non : on rebranche le comportement ici.
  function initContactPopups() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-contact-popup-trigger]');
      if (trigger) {
        var popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
        if (popup) {
          popup.hidden = false;
          // Réouverture propre : on repart de la question, pas de la
          // réponse choisie la fois précédente.
          popup.querySelectorAll('[data-help-reveal]').forEach(function (el) { el.hidden = true; });
        }
        return;
      }

      // Choix « Par téléphone » / « Par e-mail » (demande utilisateur,
      // 2026-08-31). Le choix e-mail est un vrai <a href="mailto:"> : on le
      // laisse s'ouvrir et on affiche juste le filet de secours en dessous.
      var choice = event.target.closest('[data-help-choice]');
      if (choice) {
        var card = choice.closest('[data-contact-popup]');
        card.querySelectorAll('[data-help-reveal]').forEach(function (el) {
          el.hidden = el.dataset.helpReveal !== choice.dataset.helpChoice;
        });
        return;
      }

      var closeEl = event.target.closest('[data-contact-popup-close]');
      if (closeEl) {
        closeEl.closest('[data-contact-popup]').hidden = true;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach(function (popup) {
        popup.hidden = true;
      });
    });
  }
  initContactPopups();

  // Retour au récapitulatif : les liens « Modifier → » du récap ajoutent
  // ?retour=recap. Dans ce mode le bouton principal ramène droit au récap.
  var RECAP_URL = '/pages/devis-7';

  function retourRecap() {
    try {
      return new URLSearchParams(window.location.search).get('retour') === 'recap';
    } catch (e) {
      return false;
    }
  }

  function nextUrl(defaultUrl) {
    return retourRecap() ? RECAP_URL : defaultUrl;
  }

  function initRetourRecap() {
    if (!retourRecap()) return;
    var next = document.querySelector('[data-nav="next"]');
    if (!next) return;
    next.textContent = 'Revenir au récapitulatif';
    var nav = next.closest('.devis-form__nav');
    var back = nav && nav.querySelector('.devis-form__btn--ghost');
    if (back) {
      back.hidden = true;
      nav.classList.add('devis-form__nav--retour');
    }
    // Même logique pour le retour discret du haut : il ramène au récap.
    var topBack = document.querySelector('.devis-topbar__back');
    if (topBack) topBack.href = RECAP_URL;
  }
  initRetourRecap();

  window.CachoteriesDevis = {
    getState: getState,
    setState: setState,
    bindForm: bindForm,
    syncForm: syncForm,
    renderProgress: renderProgress,
    isPro: isPro,
    attachInvalidStyling: attachInvalidStyling,
    showBlocage: showBlocage,
    hideBlocage: hideBlocage,
    nextUrl: nextUrl,
    retourRecap: retourRecap,
    FORMATS: FORMATS,
    formatByKey: formatByKey,
    nommer: nommer,
    qteFormat: qteFormat,
    totalBiscuits: totalBiscuits,
    detailFormats: detailFormats
  };
})();
